import React from 'react';
import LiveStreamTable from './LiveStreamTable';

const LiveStreamManagement = () => {
  return <LiveStreamTable />;
};

export default LiveStreamManagement;